import { 
  getOuterUserList, 
  getTravelerList,
  getBankList,
  getOuterUserInfo,
  addOuterUser,
  deleteOuterUser,
  getTravelInfo
} from '../services';

import { reqExpenseType } from '@/routes/Apply/services';

export default {
  namespace: 'externalPerson',
  state: {

  },
  effects: {
    * getOuterUserList ({ payload }, { call }) {
      return yield call(getOuterUserList, payload);
    },

    * getTravelerList ({ payload }, { call }) {
      return yield call(getTravelerList, payload);
    },

    * getCommonDic ({ payload }, { call }) {
      return yield call(reqExpenseType, payload);
    },
    
    * getBankList ({ payload }, { call }) {
      return yield call(getBankList, payload);
    },

    * addOuterUser ({ payload }, { call }) {
      return yield call(addOuterUser, payload);
    },

    * deleteOuterUser ({ payload }, { call }) {
      return yield call(deleteOuterUser, payload);
    },

    * getOuterUserInfo ({ payload }, { call }) {
      return  yield call(getOuterUserInfo, payload);
    },
    
    * getTravelInfo ({ payload }, { call }) {
      return yield call(getTravelInfo, payload);
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  }
};